import React, { useState } from "react";
import Category from "../../../../Constant/CaterogyData";
import Categorycard from "../../../../Components/Card/Categorycard/Categorycard";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const ITEMS_VISIBLE = 4;

const CategoryHeader = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const totalItems = Category.length;
  const maxIndex = totalItems - ITEMS_VISIBLE;

  const handleNext = () => {
    if (currentIndex < maxIndex) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <div className="relative w-full mx-auto  py-3 mb-5 bg-white ">
      <button
        onClick={handlePrev}
        className="absolute left-2 top-1/2 transform -translate-y-1/2 z-10 bg-white shadow-md rounded-full p-2 hover:bg-gray-100 disabled:opacity-30"
        disabled={currentIndex === 0}
      >
        <FaChevronLeft />
      </button>

      <div className=" w-11/12 mx-auto  ">
        <div
          className=" w-full flex gap-2 transition-transform duration-500 "
          style={{
            transform: `translateX(-${currentIndex * (100 / ITEMS_VISIBLE)}%)`,
            width: `${(Category.length * 100) / ITEMS_VISIBLE}%`,
          }}
        >
          {Category.map((item) => (
            <div key={item.id} className="w-1/3  ">
              <Categorycard {...item} /> 
            </div>
          ))}
        </div>
      </div>

      <button
        onClick={handleNext}
        className="absolute right-2 top-1/2 transform -translate-y-1/2 z-10 bg-white shadow-md rounded-full p-2 hover:bg-gray-100 disabled:opacity-30"
        disabled={currentIndex >= maxIndex}
      >
        <FaChevronRight />
      </button>
    </div>
  );
};

export default CategoryHeader;
